<template>
	<div class="qualityenterprise">
		<leftnav class="fl" :mkcode="curWebsite.type == 5 ? 'DB':'A'" itemcode="A-ZSDT"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<!-- <span class="fl right_title1 " @click="routerself('/enterprise-mapsearch')">企业{{curWebsite.mapname}}地图</span> -->
						<span class="fl right_title1 ml-3" @click="routerself('/building-mapsearch')"  v-if="curWebsite.type == 3 || curWebsite.type == 4">楼宇{{curWebsite.type == 4 ? '数字' : '招商'}}地图</span> 
						<span class="fl right_title1 ml-3 current" v-if="curWebsite.type != 3 ">拿地项目{{curWebsite.mapname}}地图</span>   
					</div>	
					<div class="opport-screen-list1"> 
					 <dl class="opport-screen bdbe">
							<dt class="fl">省份地区</dt>
							<dd class="fl"> 
								<span  :key="index" v-for="(item,index) in provincedata" @click="provincechoose(item); " :class="item.areaId == provinceID?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length!=0">
							<dt class="fl">城市地区</dt>
							<dd class="fl">
								<!--  v-show="zhixiaCity(provinceID)" -->
								<span :class="cityID == 0?'current a-screen':'a-screen'" @click="choosecity('all'); " v-show="zhixiaCity(provinceID)">全部</span>
								<span  :key="index" v-for="(item,index) in citydata" @click="choosecity(item);  " :data="item.areaId" :class=" item.areaId == cityID ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="countydata.length!=0">
							<dt class="fl">区县地区</dt>
							<dd class="fl"> 
							<span :class="countyID == 0?'current a-screen':'a-screen'" @click="choosecounty('all'); ">全部</span>	
								<span :key="index" v-for="(item,index) in countydata" @click="choosecounty(item); " :data="item.areaId"	:class=" item.areaId == countyID ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">热点产业</dt>
							<dd class="fl">
								<span :class="industrycode1 == 0?'current a-screen':'a-screen'" @click="industrychoose(1,{children:[],value:0}); ">全部</span>
								<span :key="index" v-for="(item,index) in hotindustry" @click="industrychoose(1,item);" :class="industrycode1 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
							<dt class="fl titleop">细分产业</dt>
							<dd class="fl">
								 <!-- <span @click="industrycode2=industrycode1;getdynamiclist()":class="industrycode2 == industrycode1?'a-screen current':'a-screen'">全部</span> -->
									<span :class="industrycode2 == 0?'current a-screen':'a-screen'" @click="industrychoose(2,{children:[],value:0}); ">全部</span>
									<span :key="index" v-for="(item,index) in hotindustrychild" @click="industrychoose(2,item);" :class="industrycode2 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl> 
					</div>
				</div>
				<div class="mapserch_mapbox  whitebox oh"> 
				<!-- 	<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{ list.length }}</span>条相关结果</p> 
					</div> -->
					<div id="testmap">
						<BGMap ref="bgmap" :type="'land'" @location="onLocation" @zoomchange="onZoomChange" @mapmove="onMapMove" @selectitem="onSelectItem"></BGMap>

						<EnterpriseDetail ref="detail" :type="3" :token="userdata.token" :model="selectItem" :pixel="selectPixel" v-if="showDetail" @close="onCloseEnterpriseDetail" @navigation="onNavigation" @navigationclose="onNavigationClose"></EnterpriseDetail>

						<div class="sider-left">
							<div class="area-bar box-shadow" style="height: 32px;">
								<!-- <el-button icon="el-icon-location-outline" size="small" @click="showCitySelect = !showCitySelect">{{areaName}}</el-button>
			            <span class="count">为您找到<span class="num">{{ list.length }}</span>家匹配的企业</span>
			            <span class="search-icon" @mouseenter="enterSearchIcon" ><i class="el-icon-search"></i></span> -->

								<!-- <transition name="fade"> v-if="showSearch"  @mouseleave="leaveSearchIcon"-->
								<div class="search-bar">
									<el-input class="search-text" ref="elSearch" placeholder="请输入搜索项目名" @keyup.enter.native="searchEnterprise" v-model="searchWord"></el-input>
										<button class="search-btn" @click="searchEnterprise"><i slot="suffix" class="el-input__icon el-icon-search"></i>查询</button>
								</div>
								<!-- </transition> -->
							</div>

							<div class="view-bar box-shadow">
								<CitySelector class="box-shadow" @select="onSelectCity" v-if="showCitySelect">
								</CitySelector>
								<div class="box-card" v-if="!showSearchResult">
									<div class="header clearfix" @click="toggleViewbar">
										<span>可视区域内为您找到<span class="num">{{ viewList.length }}</span>条拿地项目</span>
										<i style="float: right; margin-top:5px;" :class="['el-icon-arrow-up', showViewbar ? 'arrow-active' : '']" type="text"></i>
									</div>
									<div class="cont" v-show="showViewbar">
										<div :class="['item', item.id == selectItem.id ? 'active' : '']" @click="onSelectItem(item)" v-for="item in mapPageList" :key="item.id">
											<div class="title">{{item.projectName}}</div>
											<div class="addr">{{item.purpose}}</div>
										</div>
										<el-pagination class="pagination" background layout="prev, pager, next" :total="mapTotal" :page-size="mapPageSize" @current-change="changePage">
										</el-pagination>
									</div>
								</div> 
								<div class="box-card search-result" v-if="showSearchResult">
									<div class="header clearfix">
										<span><span class="kw">{{ searchWord}}</span> 共搜索到 <span class="num">{{ searchList.length }}</span>条拿地项目</span>
										<i @click="closeSearchBar" style="float: right; margin-top:5px;" class="el-icon-close" type="text"></i>
									</div>
									<div class="cont">
										<div :class="['item', item.id == selectItem.id ? 'active' : '']" @click="onSelectItem(item)" v-for="item in searchList" :key="item.id">
											<div class="title" v-html="formatSearchTitle(item.projectName)"></div>
											<div class="addr">{{item.address}}</div>
										</div> 
									</div>
								</div>
							</div>
						</div> <!-- left end -->

						<div class="sider-right">
							<div class="tool-bar">
								<el-button class="btn-me" type="info" size="small" plain circle title="我的位置" @click="setUserPosition" icon="el-icon-location"></el-button>
								<el-button-group>
									<el-button size="small" :type="isLoadNet ? 'primary' : 'default'" icon="iconfont icon-lukuang" @click="toggleLoadNet">路况</el-button>
									<el-button size="small" :type="isSatellite ? 'primary' : 'default'" icon="iconfont icon-weixing" @click="toggleSetallite">卫星</el-button>
								</el-button-group>
							</div>

						</div>
			 	</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { landTypeData,landIndustryData,landCityData } from "@/utils/landMapParameter.js";
	import BGMap from '../enterpriseInc/bgmap';
	import EnterpriseDetail from '../enterpriseInc/enterprise-detail';
	import CitySelector from '../enterpriseInc/city-selector';
	import notify from '@/utils/notify';
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'landmapsearch',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				userdata: {},
				// mapurl: '',
				time: '',
				curWebsite:this.$api.getWebsiteType(),
				title: "地图搜索",
				searchPlaceholder: '请输入企业名称', 
				currentcity:{
					type:"city",id:4301
				}, 
				searchtype: 0,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				//拿地行业参数
				industryid:0,
				industrycode1:0,
				industrycode2:0, 
				landType:0,
				hotindustry:landIndustryData(),
				hotindustrychild:[],
				//城市区县参数
				provinceID: 0,
				cityID: 0,
				countyID: 0,
				provincedata: landCityData(),
				zhixiaCitydata: [11,12,50,31],
				citydata: [],
				countydata: [],
				//分页参数
				page: 1, //显示的是哪一页 
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数  
				searchtagdata: ['0'],
				//地图相关参数
				mapUtil: null,
				position: [],
				userInfo: {},
				showViewbar: false,
				list: [],
				viewList: [],
				mapPageList: [],
				mapPage: 1,
				mapPageSize: 10,
				mapTotal: 1,
				selectItem: {},
				selectPixel: null,
				showDetail: false,
				showCitySelect: false,
				areaId: 0,
				areaName: '',
				driving: null,
				isLoadNet: false,
				isSatellite: false,
				searchWord: '',
				showSearch: true,
				showSearchResult: false,
				searchList: [],
				searchTimerId: 0,
				//item.longitude,item.latitude
				cityLand:[],
				onloadbtn:true,
				// areadata: dataInJs(),
			}
		},
		components: {
			BGMap,
			EnterpriseDetail,
			CitySelector
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			
			this.userdata = this.getuseriformation();    
		},
		mounted() {  
			// this.provincechoose({areaId:this.userdata.province},'onload'); 
			this.mapUtil = this.$refs.bgmap.getMapUtil();
			// this.mapurl = this.$api.cyl.govementchart.mapserch() + '?token=' + this.userdata.token + "&date=" + this.time; 
		},
		methods: {  
			//招商地图map相关  页面筛选数据函数
			onLocation({ 	position, area }) {
				console.log('index1', position, area);
				this.position = position; //旧版location 已暂停
				this.provincechoose({areaId:this.userdata.province},'onload'); 
			},
			loadData(type) {   
				this.bus.$emit('loading', true); 
					var industryja1 =this.splicing('industry1',this.industrycode1);
					var industryja2 =this.splicing('industry2',this.industrycode2); 
					var cityJa =this.splicing('city',this.cityID); 
					var provinceja =this.splicing('province',this.provinceID); 
					var countyJa =this.splicing('county',this.countyID);   
					var _this=this;
					var ajaxurl=this.$api.enterpriseapi.land.list()+'?pageSize=1000&map=1'+ industryja1+ industryja2+provinceja+cityJa+countyJa;  
					// console.log('ajaxurl',ajaxurl) 
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(res => { 
					_this.onloadbtn=false;
					var data = res.data;
					_this.list = data.list || []; 
					console.log('筛选loadData',ajaxurl);
					for(var i=0;i<_this.list.length;i++){
						_this.list[i].type=1;
					}
					console.log()
					if(	_this.list.length>0){ 
						if(_this.countyid!=0){
								_this.cityLand=[_this.list[0].lng,_this.list[0].lat];
						}else{
							_this.cityLand=_this.position;
						}  
					}
					_this.mapUtil.moveTo(_this.cityLand);
					_this.setViewList();
					_this.bus.$emit('loading', false); 
					_this.bus.$emit('loading', false); 
				});
			},
			//省份城市选择 intype 初始化时只需要展开数据 不需要去搜索数据
			provincechoose(item,intype) {
				if(this.provinceid != item.areaId){  
					let curcitydata=this.provincedata.filter(list=>{
						return list.areaId == item.areaId;
					})
					item =intype=='onload'?curcitydata[0]:item;
					this.provinceID = item.areaId;  
					this.cityLand=[item.longitude,item.latitude];//item.longitude,item.latitude  
					this.citydata=item.children ?item.children:[]; 
					let iszhixia=this.zhixiaCity(item.areaId);
					if(intype == "onload"){
						if(this.userdata.cityText!=''){
							this.choosecity({areaId:this.userdata.city})
						} 
					}else {
						if(iszhixia){
							this.cityID = 0;
							this.countyID = 0;
							this.loadData(); 
						}else{
							let id1=this.citydata[0].areaId;
							this.choosecity(this.citydata[0])
						} 
					}
				
				}
			},
			choosecity(item) {
				//	console.log('choosecity',id); 
					// this.ttsg(); 
					if(item == 'all'){
						this.cityID=0;this.countyID = 0;this.countydata =[];
					}else{
						// let curcitydata=this.citydata.filter(list=>{
						// 	return list.areaId == item.areaId;
						// })
						// item=curcitydata[0];  
						if(this.cityID != item.areaId || this.cityID == this.userdata.city){
							this.cityID = item.areaId; this.countyID = 0;
							this.countydata = item.children ? item.children :[];
							this.cityLand=[item.longitude,item.latitude];
						}
					} 
					this.areaName=item.areaName;
					this.loadData();
				
			},
			choosecounty(item) {
				//	console.log('choosecity',id);
				if(item == 'all'){
						this.countyID=0;
				}else{
					this.countyID = item.areaId;
					this.cityLand=[item.longitude,item.latitude];
				}  
				this.loadData();
			}, 
			zhixiaCity(id){ 
				return id == 11 || id == 31 || id == 12 || id == 50;
			},
			//土地所属行业筛选
			industrychoose(step,list){
				if(list.value == this.industryid){return;}
				var dtsg=[];
			 if(step == 1){
					this.hotindustrychild=list.children; 
					this.industrycode2='';
					this.industrycode1=list.value;
				}else if(step == 2){
					this.industrycode2=list.value;
				};
				this.industryid=list.value;
				this.loadData();
			} ,
			//地图插件函数
			onSelectCity(city) { 
				if (city.id != this.areaId) {
					this.areaId = city.id;
					this.areaName = city.name;
					this.mapUtil.setCity(city.name, city);
					this.loadData(city.id);
				}
				this.showCitySelect = false;
			},
			// onLocation({ 	position, area }) { 
			// 	console.log('index1', position, area);
			// 	this.position = position; //旧版location 已暂停
			// 	this.provincechoose({areaId:this.userdata.province},'onload');
			// 	return; 
			// 	let usercity=this.userdata.currentCity;
			// 	let usernotion=this.userdata.notion;
			// 	var province = this.splicing('province', this.provinceID);
			// 	var city = this.splicing('city', this.cityID);
			// 	var county = this.splicing('county', this.countyID);
			// 	var notion = this.splicing('notion', this.userdata.notion);
			// 	var tag = this.splicing('tag', this.userdata.tag);
			// 	var ajaxurl = this.$api.cyl.map.enterpriseList() + '?page=1' + province + city + county + notion+tag,	_this = this; 
				
				
			//  this.$axios.get(ajaxurl, {
			//  	headers: {
			//  		AuthToken: this.userdata.token
			//  	}
			//  }).then(res => { 
			//  	var data = res.data;
			//  	_this.list = data.list || [];
			//  	console.log('初始化城市+推荐',ajaxurl,this.list);
			//  	if(	_this.list.length>0){ 
			//  		_this.mapUtil.moveTo([this.list[0].lng, this.list[0].lat]);
			//  		_this.setViewList();
			//  	} 
			//  	_this.bus.$emit('loading', false); 
			//  }); 
			// },
			onZoomChange(zoom) {
				this.setViewList();
			 // if(this.showDetail){
				//     this.selectedPixel = this.$refs.bgmap.refreshMap(this.selectItem);
				// }
			},
			onMapMove(center) {
				this.setViewList();
			},
			onCloseEnterpriseDetail() {
				this.showDetail = false;
				this.selectItem = {};
				this.selectPixel = {};
			},
			onSelectItem(data) { 
				if (data.id != this.selectItem.id) {
					this.mapUtil.moveTo([data.lng, data.lat]);
					this.selectItem = data;
					this.showDetail = true;
					this.selectPixel = this.$refs.bgmap.showSelectItem(data);
				}
			},
			onNavigation(type) {
				console.log('navigation', type);
				this.driving = this.mapUtil.navigation({
			 	type,
					from: this.position,
			 	to: [this.selectItem.lng, this.selectItem.lat],
					city: this.areaName,
					panel: 'navigationPanel',
					callback: success => {
						this.$refs.detail.onNavigationComplete(success);
					}
				});
			},
			onNavigationClose() {
				if (this.driving) {
					this.driving.clear();
				}
			},
			toggleViewbar() {
				this.showViewbar = !this.showViewbar;
			},
			setViewList() {
				if (!this.list || this.length == 0 || this.showSearchResult) {
					return;
				}
				//var mapUtil = this.$refs.bgmap.getMapUtil();
				this.viewList = this.mapUtil.getViewList(this.list);
				this.$refs.bgmap.setData(this.viewList);
				this.changePage(1);
				this.mapTotal = this.viewList.length;
			},
			setSearchList() {
				this.$refs.bgmap.setSearchData(this.searchList);
			},
			setUserPosition() {
				this.mapUtil.moveTo(this.position);
			},
			changePage(page) {
				this.mapPage = page;
			 var start = (page - 1) * this.mapPageSize;
				var end = start + this.mapPageSize;
				this.mapPageList = this.viewList.filter((o, i) => i >= start && i < end);
				console.log('mapPageList',this.mapPageList[0]);
			},
			toggleLoadNet() {
			 this.isLoadNet = !this.isLoadNet;
				if (this.isLoadNet) {
					this.mapUtil.addLoadNet();
				} else {
					this.mapUtil.removeLoadNet();
				}
			},
			toggleSetallite() {
				this.isSatellite = !this.isSatellite;
				if (this.isSatellite) {
					this.mapUtil.addSatellite();
				} else {
					this.mapUtil.removeSatellite();
				}
			},
			enterSearchIcon() {
				//console.log('enter');
				this.showSearch = true;
				setTimeout(() => {
					this.$refs.elSearch.focus();
				}, 500);
			},
			leaveSearchIcon() {
				//console.log('leave');
				this.showSearch = this.showSearchResult || false;
			},
			searchEnterprise(kw) {
				clearTimeout(this.searchTimerId); 
				this.showSearchResult = this.searchWord != ''; 
				if (this.showSearchResult) {
					// this.searchList = this.list.filter(x => x.title.indexOf(kw) >= 0);
					this.bus.$emit('loading', true);
					var ajaxurl = this.$api.enterpriseapi.land.list()+'?pageSize=1000&map=1&province=0&city=0&kw='+this.searchWord,
						_this = this; 
						console.log(ajaxurl)
					this.getAxiosData(ajaxurl, this.userdata.token, function(res) {
						 
						_this.searchList = res.list;
						_this.bus.$emit('loading', false);
					}) 
					
					
				} else {
					this.searchList = [];
				}
				this.searchTimerId = setTimeout(_ => {
					this.setSearchList();
				}, 1000);
			},
			formatSearchTitle(title) {
				return title.replace(this.searchWord, '<span class="redfont">' + this.searchWord + '</span>');
			},
			closeSearchBar() {
				this.showSearch = false;
				this.showSearchResult = false;
			 this.searchWord = '';
				this.searchList = [];
				this.setViewList();
			},
			//地图相关结束
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.ajaxsearchcompany(1, 'srot', 'search');
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			getCurrentTime() {
				//获取当前时间
				var _this = this;
				let yy = new Date().getFullYear();
				let mm = new Date().getMonth() + 1;
				let dd = new Date().getDate();
				let hh = new Date().getHours();
				let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
				let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
				// 　　_this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss; 
				this.time = yy + '-' + mm + '-' + dd + ' ';
			},
		},
	}
</script>

<style>
	/* @import "../../../css/index.css"; */



	/* 	.mapserch_mapbox{
		width: 100%;
		height: 40%;
		border: 1px solid red;
	} */
</style>
<style lang="scss" scoped>
	.box-shadow {
		background: #fff;
		border-radius: 4px;
		box-shadow: 0 0 8px rgba(0, 0, 0, .1);
	}

	body .el-card__header {
		padding: 13px 20px;
	}

	body .fade-enter-active {
		transition: width 2s;
	}

	body .word {
		color: #c00;
		font-weight: bold;
	}

	.sider-left {
		position: absolute;
		left: 20px;
		top: 20px;
		font-size: 14px;
		text-align: left;
		width: 380px;
		color: #000;
	}

	.area-bar {
		padding: 10px;
		position: relative;

		.count {
			margin: 0 10px;
		}

		.search-icon {
			float: right;
			margin-top: 7px;
			margin-right: 6px;
			font-size: 18px;

			&:hover {
				color: #39f;
			}
		}

		.el-icon-close {
			font-size: 18px;
		}
  .el-input__icon.el-icon-search{
			width: 18px;color: #5E83CC;
		}
		.search-bar {
			position: absolute;
			left: 0;
			top: 0;
			width: 98%;
			height: 100%;

			//display:none;
			.search-text {
				margin: 5px 4px;width: 300px;
			}
			.search-btn{
				width: 60px; color: #5E83CC;
				
			}

		}
	}

	.num,
	.kw {
		color: rgb(16, 111, 189);
		font-weight: bold;
		margin: 0 8px;
	}

	.tool-bar {
		position: absolute;
		top: 20px;
		right: 20px;
		text-align: left;

		.btn-me {
			color: #c00;
			margin-right: 20px;
			padding: 3px;
			font-size: 22px;

			i {
				font-size: 24px;
			}

			&:hover {
				background: #e4f1ff;
				color: #f00;
			}
		}
	}
</style>
<style scoped lang="scss">
	#testmap {
		position: relative;
		width: 95%;
		margin: 0 auto 20px;
		// width: 100%;position: relative;
		overflow-y: hidden;
		overflow: hidden;
		height: 93.6vh;
	}

	.kw {
		color: #c00;
	}

	.el-icon-arrow-up {
		transition-duration: 0.2s;
	}

	.arrow-active {
		transform: rotate(180deg);
		transition-duration: 0.2s;
	}

	.view-bar {
		margin-top: 12px;
		position: relative;

		.box-card {
			.header {
				padding: 15px 20px;
			}

			.cont {
				padding: 5px 0;
				border-top: 1px solid #eee;
				height: 600px;
				overflow-y: scroll;

				.item {
					cursor: default;
					padding: 0 20px;
				}

				.active {
					background: #eee;

					.title {
						color: #f50;
					}
				}
			}

			.title {
				font-size: 16px;
				padding: 10px 0;
				font-weight: bold;
				color: rgba(9, 22, 49, 0.842);
			}

			.addr {
				font-size: 12px;
				color: #555;
				border-bottom: 1px solid #eee;
				padding: 5px 0 10px;
			}
		}

		.pagination {
			padding: 10px 0;
		}
	}
</style>
